import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { RetakeButton } from 'page/ProfileScreen/Selfies/buttons/RetakeButton'
import { TakeButton } from 'page/ProfileScreen/Selfies/buttons/TakeButton'
import { UploadButton } from 'page/ProfileScreen/Selfies/buttons/UploadButton'
import { CameraInput } from 'page/ProfileScreen/Selfies/CameraInput'
import { Or } from 'page/ProfileScreen/Selfies/Or'
import { uploadQrModal, UploadQrModalStore } from 'page/ProfileScreen/UploadQrModal/UploadQrModalStore'
import { useEffect, useState } from 'react'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { isMobileBrowser } from 'util/mobile'

export const CameraPanel = observer(() => {
  const { picture, selfies, camera } = store.profile.common
  const { seconds } = camera
  const stand = opt.stand
  const error = camera.error || selfies.find(it => it.error)?.error
  const errors = !!error
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(isMobileBrowser())
  }, [])

  const onSwitchCamera = useLatestCallback(async () => {
    await camera.switchCamera()
  })

  const onCancel = useLatestCallback(() => {
    store.profile.camera = false
    controller.closeSelfieBanner()
  })

  const onUpload = useLatestCallback(() => {
    uploadQrModal.open(new UploadQrModalStore())
  })

  const hasMultipleCameras = camera.hasMultipleCameras
  const showCancelButton = !isMobile && !opt.camera

  const upload = opt.qr_upload && <UploadButton onUpload={onUpload} />
  const retake = <RetakeButton />
  const take = <TakeButton />

  return (
    <Vertical gap={opt.stand ? 32 : 12} center>
      <CameraInput />
      {!error && !seconds && (
        <Typo size={opt.stand ? 20 : 12} center secondary>
          {i18n('SelfieShortRequirements')}
        </Typo>
      )}
      {!!error && (
        <Typo size={opt.stand ? 20 : 12} center error>
          {error}
        </Typo>
      )}

      {isMobile && hasMultipleCameras && !stand && (
        <>
          <Button
            text
            flat
            wide
            action={onSwitchCamera}
            icon={<Icon size={16} name="flip_camera_ios" />}
          >
            {camera.isFrontCamera ? i18n('RearCamera') : i18n('FrontCamera')}
          </Button>
          <Gap height={8} />
        </>
      )}

      {(picture || errors) && (opt.stand ? (
        <Vertical gap={12} wide>
          {retake}
          {upload && <Or />}
          {upload}
        </Vertical>
      ) : (
        <Space gap={12} wide>
          {upload}
          {retake}
        </Space>
      ))}

      {(!picture && !errors) && !seconds && (opt.stand ? (
        <Vertical gap={16} wide>
          {take}
          {upload && <Or />}
          {upload}
        </Vertical>
      ) : (
        <Space gap={12} wide>
          {upload}
          {take}
        </Space>
      ))}

      {showCancelButton && (
        <>
          <Button
            text
            flat
            wide
            action={onCancel}
            icon={<Icon size={16} name="close" />}
          >
            {i18n('Cancel')}
          </Button>
        </>
      )}
    </Vertical>
  )
})
